import {
  clampCardOrderCreateStep,
  type CardOrderCreateDraft,
} from "./card-orders.interface";

const STORAGE_KEY = "gsignature.card-order-create-draft";

export function loadCardOrderCreateDraft(): CardOrderCreateDraft | null {
  if (typeof sessionStorage === "undefined") {
    return null;
  }
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as CardOrderCreateDraft;
    if (parsed.version !== 1) {
      return null;
    }
    return {
      ...parsed,
      stepIndex: clampCardOrderCreateStep(parsed.stepIndex),
      selectedBranchIds: Array.isArray(parsed.selectedBranchIds)
        ? parsed.selectedBranchIds
        : [],
      selectedEmployees: Array.isArray(parsed.selectedEmployees)
        ? parsed.selectedEmployees
        : [],
      cartLines: Array.isArray(parsed.cartLines) ? parsed.cartLines : [],
      checkoutForm: {
        line1: "",
        line2: "",
        city: "",
        postalCode: "",
        country: "PL",
        phone: "",
        recipientName: "",
        companyName: "",
        deliveryType: "COURIER",
        deliverySpeed: "STANDARD",
        notes: "",
        accessPointId: "",
        ...parsed.checkoutForm,
      },
    };
  } catch {
    return null;
  }
}

export function saveCardOrderCreateDraft(draft: CardOrderCreateDraft): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
}

export function clearCardOrderCreateDraft(): void {
  if (typeof sessionStorage === "undefined") {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEY);
}
